/* unplugin-vue-components disabled */import { render } from "./AccessibilityStatementVue.vue?vue&type=template&id=c6047ad2&scoped=true&ts=true"
import script from "./AccessibilityStatementVue.vue?vue&type=script&lang=ts"
export * from "./AccessibilityStatementVue.vue?vue&type=script&lang=ts"

import "./AccessibilityStatementVue.vue?vue&type=style&index=0&id=c6047ad2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6047ad2"]])

export default __exports__